angular.module('bribac.views.search', [
  'ngRoute',
  'ui.bootstrap',
  'bribac.translations',
  'bribac.values',
  'bribac.services.api',
  'bribac.components.searchForm',
  'bribac.components.whenLoaded',
  'bribac.components.subjectDetails',
  'bribac.components.agentDetails',
  'bribac.components.organizationDetails',
  // 'bribac.components.mainGroupDetails',
  // 'bribac.components.subGroupDetails'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/search', {
      templateUrl: 'search-view.html',
      controller: 'SearchViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}},
      reloadOnSearch: false
    })
  })

  .controller('SearchViewCtrl', function(
    $location,
    $scope,
    SEARCH_QUERY_MINLENGTH,
    SEARCH_REULTS_PER_PAGE,
    api,
    permissions
  ) {

    var $ctrl = this
    $ctrl.permissions = permissions
    // Set $location on the scope so we can use it in the $watch expression.
    $scope.$location = $location

    $ctrl.SEARCH_REULTS_PER_PAGE = SEARCH_REULTS_PER_PAGE
    $ctrl.results = {}
    $ctrl.page = 1

    $ctrl.domains = [
      {i18n: 'views.search.domains.everything', value: ''},
      {i18n: 'views.search.domains.subjects', value: 'SUBJECT'},
      {i18n: 'views.search.domains.agents', value: 'AGENT'},
      {i18n: 'views.search.domains.mainGroups', value: 'MAINGROUP'},
      {i18n: 'views.search.domains.subGroups', value: 'SUBGROUP'}
    ]

    $ctrl.onDomainChange = function() {
      $location.search('domain', $ctrl.domain || null)
      if (!$ctrl.query) {
        // There won't be any results when there is no query and it's quite
        // useless to fill up the location history with just domain filter
        // changes so we replace the current history state instead of adding a
        // new one.
        $location.replace()
      }
    }

    $ctrl.onPageChange = function() {
      $location.search('page', $ctrl.page > 1 ? $ctrl.page : null)
    }

    var searchTimeout
    // For mapping domain results to the same structure as global results so we
    // can use the same structure in the template.
    var domainToResultsKeyMap = {
      AGENT: 'agents',
      SUBJECT: 'subjects',
      MAINGROUP: 'mainGroup',
      SUBGROUP: 'subGroups',
      ORGANIZATION: 'organizations',
      IBAC: 'ibacs',
    }

    function search() {
      // Delay the search slightly so we don't search twice when the watchers
      // are initialized or when the search changes fast, like when clicking the
      // browser Back button rapidly.
      clearTimeout(searchTimeout)

      searchTimeout = setTimeout(function() {
        var params = $location.search()
        var query = params.query
        var domain = (params.domain || '').toUpperCase()

        if (query && query.length >= SEARCH_QUERY_MINLENGTH) {
          $ctrl.searchPromise = api.search({
            queryMap: {query: query},
            domain: domain,
            page: $ctrl.page,
            limit: SEARCH_REULTS_PER_PAGE
          }).then(
            function success(request) {
              $ctrl.results = {}
              $ctrl.resultsDomain = domain || null
              if (domain) {
                $ctrl.results[domainToResultsKeyMap[domain]] = request.data.list
                $ctrl.totalItems = request.data.total
                $ctrl.showPagination = request.data.list.length < request.data.total
              } else {
                var maxLength = 0
                var pagination = false
                Object.keys(request.data).forEach(function (key) {
                  maxLength = maxLength < request.data[key].total ? request.data[key].total : maxLength
                  pagination |= request.data[key].list.length < request.data[key].total
                  $ctrl.results[key] = request.data[key].list
                })
                $ctrl.totalItems = maxLength
                $ctrl.showPagination = pagination
              }
            }
          )
        }
      }, 100)
    }

    $scope.$watch('$location.search().query', function(newVal) {
      $ctrl.query = newVal
      $ctrl.page = 1
      search()
    })

    $scope.$watch('$location.search().domain', function(newVal) {
      $ctrl.domain = (newVal || '').toUpperCase()
      $ctrl.page = 1
      search()
    })

    $scope.$watch('$location.search().page', function(newVal) {
      $ctrl.page = parseInt(newVal) || 1
      search()
    })

    if ($ctrl.permissions.canManageOrganizations()) {
      var org = {i18n: 'views.search.domains.organizations', value: 'ORGANIZATION'}
      $ctrl.domains.push(org)
    }

    if ($ctrl.permissions.canManageIbacs())
      $ctrl.domains.push({i18n: 'views.search.domains.ibacs', value: 'IBAC'})
  })
